import { patientCoverages } from './coverages';
import { patientDetails } from './details';
import { patientPreferences } from './preferences';

export const patientFields = {
    ...patientCoverages,
    ...patientDetails,
    ...patientPreferences,
};
